export default __webpack_public_path__ + "static/media/2026_April_LZ.67349bbf.webp";